import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

// 应用初始状态
const state = {
  language: 'CN',
  LangIndex: 1,
  isPC: '',
  activeName: '',
  currentPath: '',
  factoryList: '',
}

// 定义所需的 getter
const getters = {

}

// 定义所需的 mutations
const mutations = {
  setLanguage(state,name) {
    state.language = name;
  },
  setLangIndex(state,index) {
    state.LangIndex = index;
  },
  setIsPC(state,type) {
    state.isPC = type;
  },
  setActiveName(state,type) {
    state.activeName = type;
  },
  setCurrentPath(state,name) {
    state.currentPath = name;
  },
  setFactoryList(state,arr) {
    state.factoryList = arr;
  },   
}

// 定义所需的 actions
const actions = {

}


// 创建 store 实例
export default new Vuex.Store({
  actions,
  getters,
  state,
  mutations
})